import React from "react";
import {
  Switch,
  Route,
  Redirect,
  RouteComponentProps,
} from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footer/Footer";
import LoginPage from "views/Pages/LoginPage";
import RegisterPage from "views/Pages/RegisterPage";
import routes, { DashRoute } from "routes";

import styles from "assets/jss/elite-feats-cms/layouts/authStyle";

import register from "assets/img/register.jpg";
import login from "assets/img/login-page.jpeg";

import error from "assets/img/clint-mckoy.jpg";
import pricing from "assets/img/bg-pricing.jpeg";

const useStyles = makeStyles(styles);

export default function Pages(props: RouteComponentProps): React.ReactElement {
  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper = React.createRef<HTMLDivElement>();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getRoutes = (routes: DashRoute[]): React.ReactNode => {
    return routes.map((prop: DashRoute, key: number) => {
      if (prop.collapse) {
        return getRoutes(prop.views!);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBgImage = () => {
    if (window.location.pathname.indexOf("/auth/register") !== -1) {
      return register;
    } else if (window.location.pathname.indexOf("/auth/login") !== -1) {
      return login;
    } else if (window.location.pathname.indexOf("/auth/pricing-page") !== -1) {
      return pricing;
    } else if (window.location.pathname.indexOf("/auth/error-page") !== -1) {
      return error;
    }
  };
  const getActiveRoute = (routes: DashRoute[]): string => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views!);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout! + routes[i].path!) !== -1
        ) {
          return routes[i].name!;
        }
      }
    }
    return activeRoute;
  };
  return (
    <div>
      {window.location.pathname !== "/auth/register" ? (
        <AuthNavbar brandText={getActiveRoute(routes)} {...rest} />
      ) : null}

      <div className={classes.wrapper} ref={wrapper}>
        <div
          className={classes.fullPage}
          style={{ backgroundImage: "url(" + getBgImage() + ")" }}
        >
          <Switch>
            {getRoutes(routes)}
            <Route path={"/auth/login"} component={LoginPage} />
            <Route path={"/auth/register"} component={RegisterPage} />
            <Redirect from='/auth' to='/auth/login' />
          </Switch>
        </div>
      </div>
    </div>
  );
}
